import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import './Card.scss';
import { DSButton } from '../Button/Button';
import { DSTheme } from '../../styles/themes/types';

interface CustomThinCardProps {
  customStyles?: string;
}

interface ThinCardProps extends CustomThinCardProps {
  title: string;
  description?: string;
  imgSrc: string;
  imgAlt: string;
  buttonText: string;
  onClick: () => void;
  special?: boolean;
}

const useStyles = makeStyles((theme: DSTheme) => ({
  thinCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '216px',
    height: '336px',
    padding: '32px',

    [theme.breakpoints.up('md')]: {
      width: '234px',
    },

    background: theme.palette.background.elevation1,
    boxShadow: '0px 5px 26px rgba(0, 0, 0, 0.06)',
    borderRadius: '16px',
  },
  thinCardContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: '100%',

    '& img': {
      width: '216px',
      height: '149px',
    },
  },
  wide: {
    width: '100%',
  },
  specialCard: {
    background: theme.palette.background.specialCard,
  },
  specialTitle: {
    color: theme.palette.primary.contrastText,
    width: '166px',
    textAlign: 'center',
  },
}));

export const ThinCard: React.FC<ThinCardProps> = ({
  title,
  description,
  imgSrc,
  imgAlt,
  buttonText,
  onClick,
  special,
}) => {
  const classes = useStyles();
  return (
    <div className={`${classes.thinCard} ${special ? classes.specialCard : ''}`}>
      <div className={classes.thinCardContent}>
        <Typography
          className={`${classes.wide} ${special ? classes.specialTitle : ''}`}
          variant="h3"
        >
          {title}
        </Typography>

        {description && <Typography>{description}</Typography>}

        <img src={imgSrc} alt={imgAlt} />

        <DSButton special={special ? 'true' : 'false'} onClick={onClick} className="wide">
          {buttonText}
        </DSButton>
      </div>
    </div>
  );
};

export const CustomThinCard: React.FC<CustomThinCardProps> = ({ children }) => {
  const classes = useStyles();
  return <div className={classes.thinCard}>{children}</div>;
};
